import React from 'react';
import styled from 'styled-components'

const TextArea = styled.textarea`
    &&& {
        padding: 5px 10px;
        width: 100%;
        border-color: #E5E5E5;
        border-width: 2px;
        &:focus {
            outline: none;
            box-shadow: none;
        }
    }
`

const Textarea = ({ placeholder, value, onChange, rows }) => {
	const handleChange = (event) => {
		if (typeof onChange === 'function') {
			onChange(event, event.target.value);
		}
	}

	return (
		<TextArea placeholder={placeholder} rows={rows} onChange={handleChange} value={value} />
	)
}

export default Textarea;
